import { getCsrfToken } from '@/integrations/php/client';

export interface PartnerReportRow {
  id: string; name: string; location: string; active: number;
  total: number; success: number; pending: number; new_leads: number; information: number; other: number;
  viewed: number; stale: number; last_lead: string | null; conversion: number; view_rate: number;
  mini_views: number; mini_calls: number; mini_maps: number;
}
export interface PartnerReportFilters {
  range: string; status: string; focus: string; sort: string; direction: string; search: string; service: string; page: number;
}
export interface PartnerReport {
  rows: PartnerReportRow[];
  summary: { partners: number; active: number; total: number; success: number; viewed: number; stale: number; followup_partners: number; conversion: number; view_rate: number };
  pagination: { page: number; pages: number; per_page: number; total: number };
  services: string[]; period: { from: string | null; to: string }; generated_at: string;
}
async function request(filters: PartnerReportFilters, csv = false, signal?: AbortSignal) {
  const params = new URLSearchParams(Object.entries(filters).map(([key, value]) => [key, String(value)]));
  if (csv) params.set('export', 'csv');
  const response = await fetch(`/api/admin/partner-reports.php?${params}`, { credentials: 'include', signal, headers: { 'X-CSRF-Token': await getCsrfToken() } });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.error?.message || 'Δεν φορτώθηκε η αναφορά συνεργατών.');
  }
  return response;
}
export async function fetchPartnerReport(filters: PartnerReportFilters, signal?: AbortSignal): Promise<PartnerReport> {
  return (await (await request(filters, false, signal)).json()).data;
}
export async function exportPartnerReport(filters: PartnerReportFilters) {
  const blob = await (await request(filters, true)).blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; link.download = `diathermiki-partners-${filters.range}.csv`;
  document.body.appendChild(link); link.click(); link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
